const getTimeFromObjectId = (id: string) => {
  if (id.length === 24) {
    return new Date(parseInt(id.substring(0, 8), 16) * 1000);
  }
  return new Date();
};

export { getTimeFromObjectId };
